import { apiWithHeader, apiWithoutHeader } from "./api";
import { BASE_URL } from "./environment";

export const deleteApiCall = (url) => {
  return apiWithoutHeader(BASE_URL)
    .delete(url)
    .catch(async function (error) {
      return error.response;
    });
};

export const deleteApiCallWithHeader = (url) => {
  const CONTENT_TYPE = "application/json";
  return apiWithHeader(BASE_URL, CONTENT_TYPE)
    .delete(url)
    .catch(async function (error) {
      return error.response;
    });
};
